export class RequestAgentCompletedTransactions{

    public   AgentID       ?:string; 
    public   TenantID      ?:string;
    public   StartDate    ?:string;
    public   EndDate      ?:string;
}